
import FormInput from "./FormInput";
import FormTextarea from "./FormTextarea";
import Btn from "./Btn";
import Page from "./Page.vue";
import FormSelect from "./FormSelect.vue";
export default {
    components: {FormSelect, Page, Btn, FormTextarea, FormInput},
    props: ['page'],
    data() {
        return {
            form: {
                f: null,
                i: null,
                phone: null,
                email: null,
                city: null,
                comment: null,
                type: null,
            },
            error: null,
            errors: null,
            process: false,
            success: false,
            types: [
                {value: 'Спортсмен', label: 'Спортсмен'},
                {value: 'Тренер', label: 'Тренер'},
                {value: 'Оптовые закупки', label: 'Оптовые закупки'},
            ]
        }
    },
    computed: {
        email() {
            return this.$config.siteCountry === 'kz' ? 'info@sevensix.kz' : 'info@sevensix.sport';
        },
    },
    methods: {
        async submit(){
            this.process = true;
            this.success = null;
            this.error = null;
            this.errors = null;
            try {
                const payload = {
                    ...this.form,
                    type: this.form.type ? this.form.type.value ?? this.form.type : null,
                };
                let response = await this.$axios.post('/api/v1/partnership/send-form', payload);
                this.success = true;
                setTimeout(this.clearForm, 5000);
            } catch (e) {
                if (e.response.status === 422) {
                    this.errors = e.response.data.errors;
                    this.error = 'Заполните корректно форму';
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                this.success = null;
                this.process = false;
            }
        },
        clearForm(){
            this.form.type = null;
            this.form.f = null;
            this.form.i = null;
            this.form.phone = null;
            this.form.email = null;
            this.form.city = null;
            this.form.comment = null;
            this.process = false;
            this.success = null;
            this.error = null;
            this.errors = null;

        },
    },
}
